import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ConciergeErrorResponse } from 'src/api/concierge';
import { appConfig } from 'src/app/app-config';

import { BookingsEndpoints, getBookingsList, Booking, BookingList } from '../api';

type QueryConfig = UseQueryOptions<
    BookingList,
    AxiosError<ConciergeErrorResponse>,
    Booking | undefined
> & {
    bypassCache?: boolean;
};

const selectUpcomingBooking = (bookings: BookingList) =>
    bookings.find(({ year }) => year === appConfig.upcomingYear);

export const useGetUpcomingBooking = (config: QueryConfig = {}) => {
    const { bypassCache, ...queryConfig } = config;

    return useQuery<BookingList, AxiosError<ConciergeErrorResponse>, Booking | undefined>({
        queryKey: [BookingsEndpoints.getMyBookings, bypassCache],
        queryFn: () =>
            getBookingsList({
                ...(bypassCache ? { bypass_cache: true } : {}),
            }),
        select: selectUpcomingBooking,
        ...queryConfig,
    } as QueryConfig);
};
